import { render } from "./footers.vue?vue&type=template&id=2c9145d0"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"

import "./footers.vue?vue&type=style&index=0&id=2c9145d0&lang=scss&Scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__